import { useEffect } from "react"

type ShortNoticeDialogProps = {
	message: string
	onAcknowledge: () => void
}

export function ShortNoticeDialog({ message, onAcknowledge }: ShortNoticeDialogProps) {
	useEffect(() => {
		const modal = document.getElementById("short_notice_modal") as HTMLDialogElement
		if (modal) {
			modal.showModal()
		}
	}, [])

	return (
		<dialog id="short_notice_modal" className="modal modal-middle">
			<div className="modal-box">
				<p className="py-4">{message}</p>
				<div className="modal-action">
					<form method="dialog">
						<button className="btn btn-primary w-full" onClick={onAcknowledge}>
							OK
						</button>
					</form>
				</div>
			</div>
			<form method="dialog" className="modal-backdrop">
				<button onClick={onAcknowledge}>close</button>
			</form>
		</dialog>
	)
}
